import TextField from '@mui/material/TextField'
import { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { IOrder } from '../../../../../../../app/entities/Order'
import { ToastNotificationContext } from '../../../../../global/context/ToastNotificationContext'
import { fetchData } from '../../../../../global/helper-functions/fetch'
import { editOrderNote } from '../../../api'
import { WoDetailContext } from '../../../context/context'
import styles from './styles.module.css'

interface IWorkOrderNotesProps {
  selectedOrder?: string
}

export default function WorkOrderNotes({
  selectedOrder,
}: IWorkOrderNotesProps) {
  const { id: orderObjectIdFromParams } = useParams()
  const id = selectedOrder || orderObjectIdFromParams

  const [note, setNote] = useState<string>('')

  const { data } = useContext(WoDetailContext)
  const { toastStatus, setToastStatus } = useContext(ToastNotificationContext)

  useEffect(() => {
    if (data.note) {
      setNote(data.note)
    }
  }, [data])

  const handleEditNote = async () => {
    try {
      await fetchData<IOrder>(editOrderNote(id ?? '', note))
      setToastStatus({ ...toastStatus, isOpen: true, severity: 'success', message: 'Note has successfully saved!' })
    } catch (err) {
      console.error(err)
      setToastStatus({ ...toastStatus, isOpen: true, severity: 'error', message: 'Error saving note!' })
    }
  }
  return (
    <>
      <div>
        <div className={styles.heading}>Work Order Note</div>
        <div className={styles.container}>
          <TextField
            sx={{ width: '100%', height: '100%' }}
            InputLabelProps={{ shrink: true }}
            multiline
            rows={10}
            label="Edit Note"
            value={note}
            onChange={(e) => {
              setNote(e.target.value)
            }}
          />
          <button
            className={styles.saveButton}
            onClick={handleEditNote}>
            Save Note
          </button>
        </div>
      </div>
    </>
  )
}
